export const GET_TIME_TO_FILL_ANALYTICS = 'GET_TIME_TO_FILL_ANALYTICS'
export const GET_TIME_TO_FILL_ANALYTICS_PENDING = 'GET_TIME_TO_FILL_ANALYTICS_PENDING'
export const GET_TIME_TO_FILL_ANALYTICS_FULFILLED = 'GET_TIME_TO_FILL_ANALYTICS_FULFILLED'
export const GET_TIME_TO_FILL_ANALYTICS_REJECTED = 'GET_TIME_TO_FILL_ANALYTICS_REJECTED'
export const SET_TIME_TO_FILL_FILTERS = 'SET_TIME_TO_FILL_FILTERS'
